import getCssRuleBySelector from './get-css-rule-by-selector';
import getCssVariablesMap from './get-css-variables-map';

const getCssTextRule = ({ customStylesheet, blockId, surfaceAttribute, name }) => {
  const cssRule = getCssRuleBySelector(customStylesheet, `#${blockId} .${surfaceAttribute}`);

  if (!cssRule) {
    return null;
  }

  const cssVariablesMap = getCssVariablesMap(cssRule.style.cssText);

  const colorRule = Object.entries(cssVariablesMap).find(([, value]) => value === `var(${name})`);

  if (!colorRule) {
    return null;
  }

  return {
    cssVariableName: name,
    textVariableName: colorRule[0],
  };
};

export default getCssTextRule;
